import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { getThinScrollBarRounded } from "../../utils/utilityFunctions/stringUtility";

const withPortalHOC = (WrappedComponent) => {
  const PortalComponent = ({
    open,
    onClose,
    borderRadius = "8px",
    yAxis = 8,
    xAxis = 0,
    containerRef,
    boxWidth,
    ...props
  }) => {
    const [position, setPosition] = useState({});
    const portalRef = useRef(null);

    const updatePosition = () => {
      if (containerRef?.current && portalRef?.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const portalRect = portalRef.current.getBoundingClientRect();
        const componentHeight = portalRect.height;
        const componentWidth = containerRect.width;

        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        const fitsBelow = containerRect.bottom + componentHeight <= viewportHeight;
        const fitsAbove = containerRect.top - componentHeight > 0;

        const fitsRight = containerRect.left + componentWidth <= viewportWidth;
        const fitsLeft = containerRect.right - componentWidth > 0;

        setPosition({
          top: fitsBelow ? containerRect.bottom + yAxis : undefined,
          bottom: !fitsBelow && fitsAbove ? viewportHeight - containerRect.top + 5 : undefined,
          left: fitsRight ? containerRect.left + xAxis : containerRect.right - componentWidth,
          width: componentWidth,
        });
      }
    };

    useEffect(() => {
      if (open) {
        const timeout = setTimeout(updatePosition, 0); // Let the DOM render first
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition, true);
        window.addEventListener("mousedown", handleOutsideClick);

        return () => {
          clearTimeout(timeout);
          window.removeEventListener("resize", updatePosition);
          window.removeEventListener("scroll", updatePosition, true);
          window.removeEventListener("mousedown", handleOutsideClick);
        };
      }
    }, [open]);

    const handleOutsideClick = (e) => {
      if (
        containerRef?.current &&
        !containerRef.current.contains(e.target) &&
        portalRef.current &&
        !portalRef.current.contains(e.target)
      ) {
        onClose();
      }
    };

    if (!open) return null;

    return ReactDOM.createPortal(
      <div
        ref={portalRef}
        className={getThinScrollBarRounded()}
        style={{
          position: "fixed",
          ...position,
          minWidth: !boxWidth && "fit-content",
          zIndex: 9999,
          background: "white",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          borderRadius: borderRadius,
          maxHeight: "fit-content",
          overflowY: "visible",
          maxWidth: "100%",
        }}
      >
        <WrappedComponent boxWidth={boxWidth} {...props} />
      </div>,
      document.body
    );
  };

  return PortalComponent;
};

export default withPortalHOC;

// old code
// import React, { useState, useEffect, useRef } from "react";
// import ReactDOM from "react-dom";
// import { getThinScrollBar, getThinScrollBarRounded } from "../../utils/utilityFunctions/stringUtility";

// const withPortalHOC = (WrappedComponent) => {
//   const PortalComponent = ({
//     open,
//     onClose,
//     borderRadius = "8px",
//     yAxis = 8,
//     xAxis = 0,
//     containerRef,
//     boxWidth,
//     ...props
//   }) => {
//     const [position, setPosition] = useState({});
//     const portalRef = useRef(null);

//     // Update dropdown position
//     const updatePosition = () => {
//       if (containerRef?.current) {
//         const rect = containerRef.current.getBoundingClientRect();
//         const viewportHeight = window.innerHeight;
//         const viewportWidth = window.innerWidth;
//         const componentHeight = 300; // Adjust as per your dropdown height
//         const componentWidth = rect.width; // Match the width of the container

//         const fitsBelow = rect.bottom + componentHeight <= viewportHeight;
//         const fitsAbove = rect.top - componentHeight > 0;

//         const fitsRight = rect.left + componentWidth <= viewportWidth;
//         const fitsLeft = rect.right - componentWidth > 0;

//         setPosition({
//           top: fitsBelow ? rect.bottom + yAxis : undefined,
//           bottom: !fitsBelow && fitsAbove ? viewportHeight - rect.top + 5 : undefined,
//           left: fitsRight ? rect.left + xAxis : rect.right - componentWidth,
//           width: componentWidth,
//         });
//       }
//     };

//     useEffect(() => {
//       if (open) {
//         updatePosition();
//         window.addEventListener("resize", updatePosition);
//         window.addEventListener("scroll", updatePosition, true); // Update position on scroll
//         window.addEventListener("mousedown", handleOutsideClick);
//       }
//       return () => {
//         window.removeEventListener("resize", updatePosition);
//         window.removeEventListener("scroll", updatePosition, true);
//         window.removeEventListener("mousedown", handleOutsideClick);
//       };
//     }, [open]);

//     // Close on outside click
//     const handleOutsideClick = (e) => {
//       if (
//         containerRef?.current &&
//         !containerRef.current.contains(e.target) &&
//         portalRef.current &&
//         !portalRef.current.contains(e.target)
//       ) {
//         onClose();
//       }
//     };

//     if (!open) return null;

//     return ReactDOM.createPortal(
//       <div
//         ref={portalRef}
//         className={getThinScrollBarRounded()}
//         style={{
//           position: "fixed",
//           ...position,
//           // minWidth: "fit-content",
//           minWidth: !boxWidth && "fit-content",
//           zIndex: 9999,
//           background: "white",
//           boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
//           borderRadius: borderRadius,
//           maxHeight: "fit-content",
//           overflowY: "visible",
//           maxWidth: "100%",
//         }}
//       >
//         <WrappedComponent boxWidth={boxWidth} {...props} />
//       </div>,
//       document.body
//     );
//   };

//   return PortalComponent;
// };

// export default withPortalHOC;
